import React from 'react';
import { Reveal } from './Reveal';
const items = [{
  title: 'CERTIFICADO ANMAT',
  text: 'Pocas marcas de proteína funcional en Argentina pueden mostrar esa garantía.'
}, {
  title: 'INDUSTRIA ARGENTINA',
  text: 'Pagás en pesos, con cuotas de MercadoPago.'
}, {
  title: 'FÓRMULA PROPIA',
  text: 'Desarrollo propio, no un genérico reenvasado con otra etiqueta.'
}, {
  title: 'NO SE CLONA EN 24HS',
  text: 'Meses de formulación y trámites regulatorios detrás. Una IA te clona una web en una tarde; la habilitación de ANMAT, no.'
}];
export function Diferenciales() {
  return <section className="bg-cream pb-[90px] text-ink" data-id="element-20">
      <Reveal className="mb-[50px]" data-id="element-21">
        <div className="bg-camel py-[30px]" style={{
        clipPath: 'polygon(0 8%, 100% 0%, 100% 92%, 0% 100%)'
      }} data-id="element-22">
          <div className="mx-auto max-w-[1100px] px-6" data-id="element-23">
            <h2 className="text-[clamp(28px,4.4vw,44px)] text-espresso-2" data-id="element-24">
              DIFERENCIALES
            </h2>
          </div>
        </div>
      </Reveal>

      <div className="mx-auto max-w-[1100px] px-6" data-id="element-25">
        <div className="grid grid-cols-1 gap-x-10 gap-y-[22px] md:grid-cols-2" data-id="element-26">
          {items.map((item, i) => <Reveal key={item.title} delay={i * 0.06} className="flex items-start gap-3.5" data-id="element-27">
              <div className="flex h-[34px] w-[34px] flex-shrink-0 items-center justify-center rounded-full border-2 border-camel text-base font-extrabold text-camel" data-id="element-28">
                ✓
              </div>
              <div className="pt-[5px] text-[15px] font-semibold" data-id="element-29">
                <b className="mb-[3px] block font-display text-[15.5px] tracking-[0.3px]" data-id="element-30">
                  {item.title}
                </b>
                {item.text}
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}